import React from 'react'
import { css } from '@emotion/react'
import { Card, mq } from 'plume-ui'
import {
  AngelShareholderData,
  InstitutionalShareholderData,
} from '../../../../../types/api'
import { CardInnerTitle } from '../../../../atoms/CardInnerTitle'
import { Table, TableCell, TableHeading } from '../../../../atoms/Table'
import { A } from '../../../../atoms/A'
import { EmptyCard } from '../../../../common/EmptyCard'
import { IGNORED_BY_WOVN_CLASS_NAME } from '@/lib/wovn'
import { LimitedToEnterpriseContents } from '../../../../common/LimitedToEnterpriseContents'
import { FormattedDate } from '../../../../atoms/FormattedDate'

type Props = {
  institutionalShareholders: InstitutionalShareholderData[]
  angelShareholders: AngelShareholderData[]
  isEnterprise: boolean
}

export const CompanyShareholders: React.FC<Props> = (props) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        column-gap: 32px;
        row-gap: 16px;
        ${mq.untilMedium} {
          flex-direction: column;
        }
      `}
    >
      <Card
        css={css`
          flex-basis: 50%;
        `}
      >
        <CardInnerTitle title="機関投資家" sub="過去の株主を含む" />
        {props.institutionalShareholders.length > 0 ? (
          <Table>
            <thead
              css={css`
                ${mq.untilMedium} {
                  display: ${props.isEnterprise ? 'initial' : 'none'};
                }
              `}
            >
              <tr>
                <TableHeading>投資家名</TableHeading>
                <TableHeading>最新ラウンド</TableHeading>
              </tr>
            </thead>
            <tbody
              css={css`
                ${mq.untilMedium} {
                  display: flex;
                  justify-content: center;
                }
              `}
            >
              {props.isEnterprise ? (
                props.institutionalShareholders?.map((s, i) => (
                  <tr key={i}>
                    <TableCell>
                      <A href={s.investor.path} decoration="none">
                        {s.investor.name}
                      </A>
                    </TableCell>
                    <TableCell>
                      {s.latestRoundDetail && (
                        <A
                          href={s.latestRoundDetail.path}
                          decoration="none"
                          className={IGNORED_BY_WOVN_CLASS_NAME}
                        >
                          {s.latestRoundDetail.roundDate ? (
                            <FormattedDate>
                              {s.latestRoundDetail.roundDate}
                            </FormattedDate>
                          ) : (
                            s.latestRoundDetail.shortname
                          )}
                        </A>
                      )}
                    </TableCell>
                  </tr>
                ))
              ) : (
                <tr>
                  <TableCell colSpan={2} align="center">
                    <LimitedToEnterpriseContents />
                  </TableCell>
                </tr>
              )}
            </tbody>
          </Table>
        ) : (
          <EmptyCard />
        )}
      </Card>
      <Card
        css={css`
          flex-basis: 50%;
        `}
      >
        <CardInnerTitle title="個人投資家" />
        {props.angelShareholders.length > 0 ? (
          <Table>
            <thead
              css={css`
                ${mq.untilMedium} {
                  display: ${props.isEnterprise ? 'initial' : 'none'};
                }
              `}
            >
              <tr>
                <TableHeading>人物</TableHeading>
                <TableHeading>最新ラウンド</TableHeading>
              </tr>
            </thead>
            <tbody
              css={css`
                ${mq.untilMedium} {
                  display: flex;
                  justify-content: center;
                }
              `}
            >
              {props.isEnterprise ? (
                props.angelShareholders?.map((s, i) => (
                  <tr key={i}>
                    <TableCell>
                      <A href={s.investor.path} decoration="none">
                        {s.investor.name}
                      </A>
                    </TableCell>
                    <TableCell>
                      {s.latestRoundDetail && (
                        <A
                          href={s.latestRoundDetail.path}
                          decoration="none"
                          className={IGNORED_BY_WOVN_CLASS_NAME}
                        >
                          {s.latestRoundDetail.roundDate ? (
                            <FormattedDate>
                              {s.latestRoundDetail.roundDate}
                            </FormattedDate>
                          ) : (
                            s.latestRoundDetail.shortname
                          )}
                        </A>
                      )}
                    </TableCell>
                  </tr>
                ))
              ) : (
                <tr>
                  <TableCell colSpan={2} align="center">
                    <LimitedToEnterpriseContents />
                  </TableCell>
                </tr>
              )}
            </tbody>
          </Table>
        ) : (
          <EmptyCard />
        )}
      </Card>
    </div>
  )
}
